import type { ProfitabilityProductCost } from '../models/Profitability';

export function formatProductCostEffectiveFrom(
  value: string | null | undefined,
  locale: string,
  baseLabel: string,
): string {
  if (value == null || value === '') return baseLabel;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
  if (!m) return value;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  if (!y || !mo || !d) return value;
  return new Date(y, mo - 1, d).toLocaleDateString(locale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function productCostLabel(row: ProfitabilityProductCost): string {
  const name = row.product_name?.trim();
  const code = row.product_code?.trim();
  if (name && code) return `${name} (${code})`;
  if (name) return name;
  if (code) return code;
  return `#${row.product_id}`;
}

export interface ProductCostGroup {
  productId: number;
  productName: string;
  productCode?: string | null;
  costs: ProfitabilityProductCost[];
}

export function sortProductCosts(costs: ProfitabilityProductCost[]): ProfitabilityProductCost[] {
  return [...costs].sort((a, b) => {
    if (a.effective_from == null) return -1;
    if (b.effective_from == null) return 1;
    return a.effective_from.localeCompare(b.effective_from);
  });
}

export function groupProductCostsByProduct(rows: ProfitabilityProductCost[]): ProductCostGroup[] {
  const map = new Map<number, ProductCostGroup>();

  for (const row of rows) {
    let group = map.get(row.product_id);
    if (!group) {
      group = {
        productId: row.product_id,
        productName: row.product_name?.trim() || productCostLabel(row),
        productCode: row.product_code,
        costs: [],
      };
      map.set(row.product_id, group);
    }
    group.costs.push(row);
  }

  return Array.from(map.values()).map((group) => ({
    ...group,
    costs: sortProductCosts(group.costs),
  }));
}
